import React from 'react';

import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';

import { validateAccess } from 'common/utils/helpers';

const LayoutRoute = ({
    component: Component,
    isHidden = false,
    isPrivate = false,
    isPublic = false,
    layout: Layout,
    redirect = { pathname: '/login' },
    requiredPermissions = [],
    ...rest
}) => {
    const hasAccess = validateAccess(requiredPermissions);

    if (isHidden) return <Redirect to={redirect} />;
    if (isPublic || (isPrivate && hasAccess) || (!isPrivate && !isPublic)) {
        return (
            <Route
                {...rest}
                render={(matchProps) => (
                    <Layout {...rest}>
                        <Component {...matchProps} />
                    </Layout>
                )}
            />
        );
    }
    return <Redirect to={redirect} />;
};

LayoutRoute.propTypes = {
    component: PropTypes.elementType,
    isHidden: PropTypes.bool,
    isPrivate: PropTypes.bool,
    isPublic: PropTypes.bool,
    layout: PropTypes.elementType,
    redirect: PropTypes.object,
    requiredPermissions: PropTypes.array,
    rest: PropTypes.object,
};

export default LayoutRoute;
